import { checkIsWhiteLabel } from '@/helpers/checkEnvironments'
import { whiteLabelsApi } from '@/helpers/whiteLabelsAPI'

const fallbackUrl = 'https://api.shab.ir/api/fa/sandbox/v_1_4'
export const getClientBaseUrl = () => {
  if (typeof window === 'undefined') return fallbackUrl
  try {
    const isWhiteLabel = checkIsWhiteLabel()
    const whiteLabelUrl = whiteLabelsApi[window.location.host]
    return (
      (isWhiteLabel && whiteLabelUrl) ||
      (window as any).RUNTIME_CONFIG?.API_BASE_URL ||
      fallbackUrl
    )
  } catch (e) {
    return fallbackUrl
  }
}
